import { z } from "zod";

export const ERROR_CODES = [
  "validation_error",
  "unauthorized",
  "not_found",
  "conflict",
  "unprocessable",
  "export_too_large",
  "internal_error",
] as const;
export const ERROR_CODE = {
  VALIDATION_ERROR: "validation_error",
  UNAUTHORIZED: "unauthorized",
  NOT_FOUND: "not_found",
  CONFLICT: "conflict",
  UNPROCESSABLE: "unprocessable",
  EXPORT_TOO_LARGE: "export_too_large",
  INTERNAL_ERROR: "internal_error",
} as const satisfies Record<string, ErrorCode>;
export const ErrorCodeSchema = z.enum(ERROR_CODES);
export type ErrorCode = z.infer<typeof ErrorCodeSchema>;
